import { render, staticRenderFns } from "./SubModulesForRoles.vue?vue&type=template&id=0dd3613d&scoped=true"
import script from "./SubModulesForRoles.vue?vue&type=script&lang=js"
export * from "./SubModulesForRoles.vue?vue&type=script&lang=js"
import style0 from "./SubModulesForRoles.vue?vue&type=style&index=0&id=0dd3613d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd3613d",
  null
  
)

export default component.exports